import { useEffect, useState } from "react";
import UniBtn, { UniBtnPack } from "./UniBtn";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import { _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3 } from "../utils/zz/zz-yourmap-utils";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import YourmapCardTeaser from "./YourmapCardTeaser";


// DEFAULT COMPONENT
// TODO presentational problems filters...
// 2026-04-24 BLOG
export const YourmapSectionOstaloV1List = (props) => {
  //
  const {
    lookup_pack,
    current_destination_entity,
    route_destination_id,
    route_destination_tab,
    ymostalo_v1_entities,
    ymostalo_v1_entities_fetching,
  } = props.appPack;
  const parent_destinacija_id = route_destination_id; // TODO
  //
  const vr_tablename = "ym_table_ostalo_v1"; // blog
  // const smestaj_tab = "OSTALO";
  // const smestaj_tab = "blog"; // blog
  let _naslov_za_list = 'Blog';
  if (route_destination_tab === 'blog') {
    _naslov_za_list = 'Blog';
  }
  if (Easy69_v1.is_string_not_empty(current_destination_entity.destinacija_naslov_sufix_za_liste)) {
    _naslov_za_list += ' ' + current_destination_entity.destinacija_naslov_sufix_za_liste;
  }
  const title = _naslov_za_list;
  _zzyourmap_routing_browser_title_update(title);

  //
  const ostalo_entites_of_destination = _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3(ymostalo_v1_entities, route_destination_id, route_destination_tab);
  const _unfiltered_entities = ostalo_entites_of_destination;

  //
  // filter by subdestinations
  console.log('* current_destination_entity', current_destination_entity);
  const [filtersSubdestinations, setFiltersSubdestinations] = useState({});
  useEffect(() => {
    setFiltersSubdestinations(state => {
      if (current_destination_entity?.of_id > 0 && Array.isArray(current_destination_entity?._subdestinations)) {
        const updated_state = {};
        current_destination_entity._subdestinations.forEach((subdestination_item) => {
          if (subdestination_item._is_main_subdestionation === true) {
            updated_state[subdestination_item._option_value_regular] = true;
          } else {
            updated_state[subdestination_item._option_value_regular] = true;
          }
        });
        return updated_state;
      } else {
        return {};
      }
    });
  }, [current_destination_entity?.of_id]);
  let filtered_entites_of_destination = _unfiltered_entities;
  // TODO da li treba filtrirati ostalo prema poddestinaciji???
  filtered_entites_of_destination = _unfiltered_entities.filter((item, index) => {
    if (item.parent_destinacija_id > 0 && filtersSubdestinations?.[item.parent_destinacija_id] === true) {
      return true;
    }
    return false;
  });
  //

  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle">
            <div className="uu-gap-standalone-1rem"></div>
            {/*<h2>Selekcija smeštaja na Zlatiboru</h2>*/}
            <h2>{_naslov_za_list}</h2>
            <p>Istraži savete, preporuke i esencijalne informacija za tvoje putovanje {/*na Zlatibor*/}</p>

            <div className="yourmap__filters">
              {
                (Array.isArray(current_destination_entity?._subdestinations)) ? (
                  <>
                    {
                      current_destination_entity._subdestinations.map((item) => {
                        return (
                          <div key={item._option_value_regular} className={"yourmap__filters__item" + (false ? " yourmap__map__subdestinations-selector__option--active" : "")}>
                            <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_image_lib_item_singular'}>
                              <span className="label">{item._option_title}</span>
                              <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                                <input
                                  type="checkbox"
                                  name={'select_image_lib_item'}
                                  readOnly={false}
                                  disabled={false}
                                  checked={filtersSubdestinations?.[item._option_value_regular] === true}
                                  onChange={() => {
                                    setFiltersSubdestinations(state => {
                                      if (state?.[item._option_value_regular] === true) {
                                        return {
                                          ...state,
                                          [item._option_value_regular]: false,
                                        };
                                      } else {
                                        return {
                                          ...state,
                                          [item._option_value_regular]: true,
                                        };
                                      }
                                    });
                                  }}
                                />
                              </span>
                            </label>
                          </div>
                        );
                      })
                    }
                  </>
                ) : (null)
              }
            </div>
            <div className="uu-gap-standalone-8px"></div>

          </div>
          <div className="yourmap__grid yourmap__grid--gaps-1rem yourmap__grid--items-w-1-3">
            {
              // rapidozi_dummysmarty_utils.item_to_arr(null, 4).map((item, index) => {
              filtered_entites_of_destination.map((item, index) => {
                return (
                  <div key={index} className="xi">
                    <YourmapCardTeaser appPack={props.appPack} item={item} />
                  </div>
                );
              })
            }
          </div>
        </div>
      </section>
    </>
  );
};

export default YourmapSectionOstaloV1List;